var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBathroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.79 17.333v4a5.333 5.333 0 01-5.334 5.334H10.122a5.333 5.333 0 01-5.333-5.334v-3.2a.8.8 0 01.8-.8h23.2zm0 0v-8A5.333 5.333 0 0023.455 4h-6.667m5.333 22.667l1.334 2.666m-12-2.666l-1.334 2.666",
    stroke: "#2C5BFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.323 10.667h-9.067c-.441 0-.795-.358-.747-.798C11.704 8.1 12.607 4 16.79 4c4.183 0 5.086 4.1 5.28 5.87.048.44-.305.797-.746.797z",
    stroke: "#2C5BFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "media/propertyTour/bathroom-9a001948.svg";
export { SvgBathroom as ReactComponent };